import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

import defaultRoutes from '@/router/defaultRoutes'
// import errorRoutes from '@/router/errorRoutes'
import sessionRoutes from '@/router/sessionRoutes'

Vue.use(VueRouter)

const routes = [...sessionRoutes, ...defaultRoutes]

Vue.router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

Vue.router.beforeResolve((to, from, next) => {
  if (to.name !== 'userSettings' && Vue.auth.user()?.state == 'onboard') {
    next({ name: 'userSettings' })
  } else {
    next()
  }
})

export default Vue.router
